import React from "react";
import { Check, X } from "lucide-react";
import { ToastType } from "./ToastProvider";

interface ToastIconProps {
  type: ToastType;
}

const ToastIcon: React.FC<ToastIconProps> = ({ type }) => {
  const iconConfig = {
    [ToastType.Success]: { color: "#22c55e", bg: "rgba(34, 197, 94, 0.15)", Icon: Check },
    [ToastType.Warning]: { color: "#eab308", bg: "rgba(234, 179, 8, 0.15)", Icon: () => <span style={{ fontSize: "1.6em", fontWeight: "bold" }}>!</span> },
    [ToastType.Error]: { color: "#ef4444", bg: "rgba(239, 68, 68, 0.15)", Icon: X },
  };

  const { color, bg, Icon } = iconConfig[type];

  return (
    <div
      style={{
        width: "50px",
        height: "50px",
        backgroundColor: bg,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
      }}
    >
      <Icon color={color} size={32} strokeWidth={3} />
    </div>
  );
};

export default ToastIcon;
